import { Component, OnInit, ViewChild } from '@angular/core';
import { AppFilter, CommonServices } from '../../../../shared';
import { environment } from '../../../../../environments/environment';
import { Subject, BehaviorSubject } from 'rxjs';
import { MentionDirective } from 'angular-mentions';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
@Component({
	selector: 'app-chat',
	templateUrl: './chat.component.html',
	styleUrls: [ './chat.component.scss' ]
})
export class ChatComponent implements OnInit {
	newComment: boolean;
	searchControl: FormControl = new FormControl('');
	customers: Array<any> = [
		{ name: 'MTN Nigeria', service_access: 'FULL ACCESS', verification_status: 'VERIFIELD', msg: 5 },
		{ name: 'Airtel Nigeria', service_access: 'FULL ACCESS', verification_status: 'VERIFIELD', msg: 5 },
		{ name: 'MTN Nigeria', service_access: 'FULL ACCESS', verification_status: 'VERIFIELD', msg: 5 },
		{ name: 'Airtel Nigeria', service_access: 'FULL ACCESS', verification_status: 'VERIFIELD', msg: 5 },
		{ name: 'MTN Nigeria', service_access: 'FULL ACCESS', verification_status: 'VERIFIELD', msg: 5 },
		{ name: 'MTN Nigeria', service_access: 'FULL ACCESS', verification_status: 'VERIFIELD', msg: 5 }
	];
	@ViewChild(MentionDirective, { static: true })
	mention: MentionDirective;
	replyForm: FormGroup;
	messageParams: AppFilter;
	filterMetaData: any;
	baseUrl = environment.API_SERVER;
	searchMessagesFilter = {
		groupOp: 'AND',
		rules: [
			{
				field: 'objectId',
				op: 'eq',
				data: ''
			}
		]
	};
	private unsubscribe$: Subject<void> = new Subject<void>();
	fileObj: any;
	pageSize: any;
	pending;
	success;
	error;
	user;
	scrollToBottom: any = true;
	replyBlock;
	users: Array<any> = [];
	organizationId: string;
	commentUsers;
	hideFromApplicant: boolean = false;
	config = {
		triggerChar: '@',
		maxItems: 10,
		labelKey: 'username',
		mentionSelect: this.onSelected.bind(this),
		dropUp: true
	};
	equipmentId: string;
	comments: Array<any> = [
		{
			commentId: '53aaa879-6391-4ae3-badd-01518a8e0411',
			objectId: 'afc16eb9-c606-4b63-b2d7-f3b4c0495995',
			comment: 'hello boi',
			objectType: 'EQUIPMENT_FIELD',
			documentId: null,
			dateCreated: '2021-11-25T12:45:02.963+0000',
			createdBy: {
				appUserId: 'cdb30e44-a164-43d6-a6bd-a3a4fdd46180',
				username: 'tamsyv2',
				name: 'Tamsy V2 Admin',
				organizationId: '05b00e13-e3be-4764-824c-9f37a288f824',
				organizationName: 'Tamsy v2'
			},
			parentCommentId: null,
			documentMetadata: null,
			parentCommentMetadata: null,
			position: 1
		},
		{
			commentId: '53aaa879-6391-4ae3-badd-01518a8e0411',
			objectId: 'afc16eb9-c606-4b63-b2d7-f3b4c0495995',
			comment: 'wat ya say!',
			objectType: 'EQUIPMENT_FIELD',
			documentId: null,
			dateCreated: '2021-11-26T12:45:02.963+0000',
			createdBy: {
				appUserId: 'casdasd0e44-ada164-43d6-a6bd-a3a4fdd46180',
				username: 'johnny',
				name: 'John Doe',
				organizationId: '05bss00e13-e3be-4764-82as4c-9f37a288f824',
				organizationName: 'Johnny'
			},
			parentCommentId: null,
			documentMetadata: null,
			parentCommentMetadata: null,
			position: 1
		}
	];
	isReply: Comment = null;
	fileName: string;
	mentionConfig$ = new BehaviorSubject<any>(this.config);
	total: number = 0;
	datasource: any;
	userMap = {};
	isContractor: boolean = false;
	modificationType: any;
	objectId: any;
	objectType: any;
	sideBarMessage: any;
	constructor(private fb: FormBuilder, private location: Location, private commonSvc: CommonServices) {
		this.replyForm = fb.group({
			comment: [ '', Validators.required ],
			hideFromApplicant: [ true ]
		});
		this.pending = true;
		this.commonSvc.getTemplate({ messageTemplateId: 'CONTACT_SIDE_BAR' }).subscribe((res: any) => {
			this.sideBarMessage = res.mailTemplate;
			this.pending = false;
		});
	}
	approvalList() {}
	goBack() {}
	onSelected(user) {
		this.userMap[user.username] = `[${user.name}](${user.appUserId})`;
		return `@${user.username}`;
	}
	search(searchText) {
		let arr = [];
		let dat = this;
		let filter = new AppFilter({ rows: 3 });
		let searchFilter = {
			groupOp: 'OR',
			rules: [
				{
					field: 'appUserEmail',
					op: 'cn',
					data: ''
				},
				{
					field: 'username',
					op: 'cn',
					data: ''
				},
				{
					field: 'firstName',
					op: 'cn',
					data: ''
				},
				{
					field: 'lastName',
					op: 'cn',
					data: ''
				}
			]
		};
		searchFilter.rules[0].data = searchText;
		searchFilter.rules[1].data = searchText;
		searchFilter.rules[2].data = searchText;
		searchFilter.rules[3].data = searchText;
		filter.filters = JSON.stringify(searchFilter);
		dat.pending = true;
		// dat.workFlowSvc
		// 	.getUsers({
		// 		organizationId: dat.modal.context.commentData["organizationId"],
		// 		params: filter,
		// 	})
		// 	.pipe(
		// 		map((res) => {
		// 			let as = [{appUserId: "Applicant", name: "Applicant", username: "Applicant"}];
		// 			res["rows"].forEach((user) => {
		// 				as.push({
		// 					username: user["username"],
		// 					appUserId: user["appUserId"],
		// 					name: user["first_name"] + " " + user["last_name"],
		// 				});
		// 			});
		// 			return as;
		// 		})
		// 	)
		// 	.subscribe((res) => {
		// 		dat.pending = false;
		// 		arr = res;
		// 		const mentionConfig = {
		// 			items: res,
		// 			triggerChar: "@",
		// 			maxItems: 10,
		// 			labelKey: "username",
		// 			mentionSelect: this.onSelected,
		// 			// mentionFilter: this.filterUser.bind(this),
		// 			dropUp: true,
		// 		};
		// 		dat.mentionConfig$.next(mentionConfig);
		// 		// dat.div.startSearch();
		// 		// this.users = arr;
		// 	});
	}
	filterUser(searchText) {
		let arr = [];
		let dat = this;
		let filter = new AppFilter({ rows: 3 });
		let searchFilter = {
			groupOp: 'OR',
			rules: [
				{
					field: 'appUserEmail',
					op: 'cn',
					data: ''
				},
				{
					field: 'username',
					op: 'cn',
					data: ''
				},
				{
					field: 'firstName',
					op: 'cn',
					data: ''
				},
				{
					field: 'lastName',
					op: 'cn',
					data: ''
				}
			]
		};
		searchFilter.rules[0].data = searchText;
		searchFilter.rules[1].data = searchText;
		searchFilter.rules[2].data = searchText;
		searchFilter.rules[3].data = searchText;
		filter.filters = JSON.stringify(searchFilter);
		dat.pending = true;

		// dat.workFlowSvc
		// 	.getUsers({
		// 		organizationId: dat.modal.context.commentData["organizationId"],
		// 		params: filter,
		// 	})
		// 	.pipe(
		// 		map((res) => {
		// 			let as = [{appUserId: "Applicant", name: "Applicant", username: "Applicant"}];
		// 			res["rows"].forEach((user) => {
		// 				as.push({
		// 					username: user["username"],
		// 					appUserId: user["appUserId"],
		// 					name: user["first_name"] + " " + user["last_name"],
		// 				});
		// 			});
		// 			return as;
		// 		})
		// 	)
		// 	.subscribe((res) => {
		// 		dat.pending = false;
		// 		arr = res;
		// 		// this.users = arr;
		// 		return arr;
		// 	});
		return arr;
	}
	getUsers(searchText) {
		let filter = new AppFilter({ rows: 15 });
		let searchFilter = {
			groupOp: 'OR',
			rules: [
				{
					field: 'appUserEmail',
					op: 'cn',
					data: ''
				},
				{
					field: 'username',
					op: 'cn',
					data: ''
				},
				{
					field: 'firstName',
					op: 'cn',
					data: ''
				},
				{
					field: 'lastName',
					op: 'cn',
					data: ''
				}
			]
		};
		searchFilter.rules[0].data = searchText;
		searchFilter.rules[1].data = searchText;
		searchFilter.rules[2].data = searchText;
		searchFilter.rules[3].data = searchText;
		filter.filters = JSON.stringify(searchFilter);
		this.pending = true;
		// this.workFlowSvc
		// 	.getUsers({
		// 		organizationId: this.organizationId,
		// 		params: filter,
		// 	})
		// 	.pipe(
		// 		map((res) => {
		// 			let arr = [{appUserId: "Applicant", name: "Applicant", username: "Applicant"}];
		// 			res["rows"].forEach((user) => {
		// 				arr.push({
		// 					username: user["username"],
		// 					appUserId: user["appUserId"],
		// 					name: user["first_name"] + " " + user["last_name"],
		// 				});
		// 			});
		// 			return arr;
		// 		})
		// 	)
		// 	.subscribe(
		// 		(res) => {
		// 			this.pending = false;
		// 			this.users = res;
		// 		},
		// 		(error) => {
		// 			this.pending = false;
		// 			this.error = error.error ? error.error : error;
		// 		}
		// 	);
	}

	getPage(page) {
		this.messageParams.page = page;
		this.pending = true;
		// this.commentSvc
		// 	.getComments({
		// 		equipmentId: this.equipmentId,
		// 		fieldId: this.objectId,
		// 		params: this.messageParams,
		// 	})
		// 	.pipe(
		// 		map((result) => {
		// 			result["rows"].forEach((comment) => {
		// 				comment["documentMetadata"] = comment["documentId"]
		// 					? JSON.parse(comment["documentMetadata"])
		// 					: "";
		// 			});
		// 			return result["rows"];
		// 		})
		// 	)
		// 	.subscribe(
		// 		(res) => {
		// 			this.pending = false;
		// 			res.forEach((comment) => {
		// 				this.comments.unshift(comment);
		// 			});
		// 		},
		// 		(error) => {
		// 			this.pending;
		// 		}
		// 	);
	}
	onScrollDown($event) {}
	onScrollUp($event) {
		let page = this.messageParams.page + 1;
		this.getPage(page);
	}
	onReply(event) {
		this.isReply = event;
	}
	removeReply() {
		this.isReply = null;
	}

	send() {
		const formData = new FormData();
		if (this.fileObj) {
			formData.append('file', this.fileObj);
		}
		let data = this.replyForm.value;
		data.hideFromApplicant = this.hideFromApplicant;
		// if (this.isReply) {
		// 	data["parentCommentId"] = this.isReply.commentId;
		// }
		let comment = data.comment;
		for (let key in this.userMap) {
			let find = `@${key}`;
			let replace = `${this.userMap[key]}`;
			comment = comment.replace(find, replace);
		}
		data.comment = comment;
		const blob = new Blob([ JSON.stringify(data, null, 2) ], { type: 'application/json' });
		formData.append('data', blob);
		this.pending = true;
		// this.commentSvc
		// 	.createComment({
		// 		equipmentId: this.filterMetaData.equipmentId,
		// 		body: formData,
		// 		fieldId: this.objectId,
		// 	})
		// 	.subscribe(
		// 		(res) => {
		// 			this.pending = false;
		// 			this.comments.push(res);
		// 			this.fileObj = null;
		// 			this.isReply = null;
		// 			this.replyForm.reset();
		// 		},
		// 		(error) => {
		// 			this.pending = false;
		// 			this.error = error.error ? error.error : error;
		// 		}
		// 	);
	}
	showReplyForm(form) {
		this.replyBlock = form;
	}

	uploadDoc($event) {
		this.fileObj = $event[0];
		this.fileName = this.fileObj['name'];
	}

  conversationsData: any[];
	ngOnInit(): void {
  }
}
